"use strict";
// CapLimit.ts
//
// Implementation of the Cap limit betting structure. Limits the max amount money
// a player can put in the pot
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapLimit = void 0;
const BettingStructure_1 = require("./BettingStructure");
/**
 * Cap Limit
 *
 * Check for the cap on how much money a player can bet during the game (the total buy in of the player)
 */
class CapLimit extends BettingStructure_1.BettingStructure {
    constructor(prefs) {
        super(prefs);
        this.validatePositiveNumber(prefs.capLimitAmount, "capLimitAmount");
        this.capLimit = prefs.capLimitAmount;
    }
    validateBet(bet, round) {
        this.validatePositiveNumber(bet.amount, "bet amount");
        if (bet.amount + bet.personalInPot > this.capLimit) {
            throw new Error(`Current bet amount of ${bet.amount} will exceed exceed the CAP_LIMIT of ${this.capLimit}`);
        }
        this.validateRaises(bet, round);
        this.validateBetSize(bet, round);
    }
}
exports.CapLimit = CapLimit;
//# sourceMappingURL=CapLimit.js.map